function getContactDetails(person = {}) {
    const email = typeof person.email === 'string' ? person.email.trim().toLowerCase() : '';
    const prefix = typeof person.prefix === 'string' ? person.prefix.trim() : '';
    const localPhone = person.phone == null ? '' : String(person.phone).replace(/\s/g, '');
    const phone = /^\+\d{1,3}$/.test(prefix) && /^\d+$/.test(localPhone)
        ? `${prefix}${localPhone}`
        : (!prefix && localPhone.startsWith('+') ? localPhone : undefined);
    const normalizedPhone = phone && /^\+[1-9]\d{10,14}$/.test(phone) ? phone : undefined;

    return {
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : undefined,
        phone: normalizedPhone,
    };
}

async function sha256(value) {
    if (!value || !globalThis.crypto || !globalThis.crypto.subtle) {
        return undefined;
    }

    try {
        const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
        return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
    } catch (error) {
        return undefined;
    }
}

function normalizeEmailForHash(email) {
    const [local, domain] = email.split('@');
    return domain === 'gmail.com' || domain === 'googlemail.com'
        ? `${local.replace(/\./g, '')}@${domain}`
        : email;
}

async function getAnalyticsContact(person) {
    const {email, phone} = getContactDetails(person);
    const [hashedEmail, hashedPhone] = await Promise.all([
        sha256(email && normalizeEmailForHash(email)),
        sha256(phone),
    ]);

    return {
        email,
        phone,
        user_data: {
            email_address: email,
            sha256_email_address: hashedEmail,
            phone_number: phone,
            sha256_phone_number: hashedPhone,
        },
    };
}

function getCartContactDetails(cart) {
    const person = Array.isArray(cart)
        ? cart.map(item => item.api_to_send_order || {}).find(item => item.email || item.phone)
        : null;
    return getContactDetails(person || {});
}

module.exports = {getContactDetails, getCartContactDetails, getAnalyticsContact};
